/* BEEA SKIN theme: the bag (Shopify AJAX cart), add buttons, gift option, mobile menu, withdrawal flow, Christmas line. */
(function () {
  'use strict';
  var B = window.BEEA || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var money = function (cents) {
    try { return new Intl.NumberFormat(B.locale || 'en', { style: 'currency', currency: B.currency || 'EUR' }).format((cents || 0) / 100); }
    catch (e) { return '€' + ((cents || 0) / 100).toFixed(2); }
  };
  var tt = function (s, v) { return String(s || '').replace(/%(\w+)%/g, function (_, k) { return v && v[k] != null ? v[k] : ''; }); };

  function req(url, body) {
    var o = { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' };
    if (body) { o.method = 'POST'; o.headers['Content-Type'] = 'application/json'; o.body = JSON.stringify(body); }
    return fetch(url, o).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  var R = B.routes || { cart: '/cart', add: '/cart/add', change: '/cart/change', update: '/cart/update' };
  function getCart() { return req(R.cart + '.js'); }

  function devByHandle(h) { for (var k in (B.devices || {})) if (B.devices[k].handle === h) return k; return null; }

  function render(c) {
    var n = c.item_count || 0;
    $$('#bagN').forEach(function (x) { x.textContent = n; });
    $$('#bagBtn').forEach(function (b) { b.classList.toggle('has', n > 0); });
    // the parts that exist in the drawer and on /cart: filled or empty, the code line, the subtotal, the gift option
    $$('[data-bag-fill]').forEach(function (x) { x.hidden = !n; });
    $$('[data-bag-empty]').forEach(function (x) { x.hidden = !!n; });
    $$('[data-bag-sum]').forEach(function (x) { x.textContent = money(c.total_price); });
    var off = Math.max(0, (c.original_total_price || c.total_price || 0) - (c.total_price || 0)) || c.total_discount || 0;
    var codes = (c.discount_codes || []).filter(function (d) { return d.applicable !== false; }).map(function (d) { return d.code; });
    if (!codes.length) codes = (c.cart_level_discount_applications || []).filter(function (d) { return d.type === 'discount_code'; }).map(function (d) { return d.title; });
    $$('[data-bag-credit]').forEach(function (x) {
      x.hidden = !(n && codes.length && off > 0);
      if (!x.hidden) x.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.2 4.2L19 7"/></svg><span>' + esc(off === 2000 && B.t.credit_applied ? B.t.credit_applied : tt(B.t.code_applied, { code: codes[0] })) + '</span><b>−' + money(off) + '</b>';
    });
    var a = c.attributes || {}, gOn = a.Gift === 'Yes';
    $$('[data-gift]').forEach(function (g) {
      var cb = $('[data-gift-on]', g), tx = $('[data-gift-text]', g), box = $('.bgmsg', g);
      if (cb && !g.contains(document.activeElement)) cb.checked = gOn;
      if (box) box.hidden = !(cb && cb.checked);
      if (tx && document.activeElement !== tx) { tx.value = a['Gift message'] || ''; var k = $('[data-gift-cnt]', g); k && (k.textContent = tx.value.length); }
    });
    var L = $('#dLines'); if (!L) return;
    var html = '';
    (c.items || []).forEach(function (it) {
      var d = devByHandle(it.handle), dv = d ? B.devices[d] : null;
      var img = dv ? dv.img : (it.image || '');
      var k = esc(it.key);
      html += '<div class="dline" data-key="' + k + '"><span class="th" style="background-image:url(' + esc(img) + ')"></span><span><b>' + esc(dv ? dv.name : it.product_title) + '</b><small>' + esc(dv ? dv.sub : (it.variant_title || '')) + '</small>' +
        '<span class="qrow"><span class="qs"><button type="button" data-qk="' + k + '" data-d="-1" aria-label="' + esc(B.t.qty_less) + '">−</button><output aria-live="polite">' + it.quantity + '</output><button type="button" data-qk="' + k + '" data-d="1" aria-label="' + esc(B.t.qty_more) + '">+</button></span>' +
        '<button class="rm" type="button" data-rm="' + k + '">' + esc(B.t.remove) + '</button></span></span><span class="q">' + money(it.final_line_price) + (it.quantity > 1 ? '<small>' + it.quantity + ' × ' + money(it.final_price) + '</small>' : '') + '</span></div>';
    });
    L.innerHTML = html;
    // one recommendation (X01): the first pairing for the first device in the bag that is not in the bag yet
    var inBag = (c.items || []).map(function (it) { return devByHandle(it.handle); }).filter(Boolean);
    var reco = '';
    if (inBag.length) {
      var base = inBag[0], pick = ((B.reco || {})[base] || []).filter(function (k) { return inBag.indexOf(k) < 0 && B.devices[k] && B.devices[k].available; })[0];
      if (pick) {
        var p = B.devices[pick];
        reco = '<div class="reco"><div class="eyebrow">' + esc(tt(B.t.pairs, { name: B.devices[base].name })) + '</div><span class="th" style="background-image:url(' + esc(p.img) + ')"></span><div><b>' + esc(p.name) + '</b><p>' + esc((B.t.reco || {})[pick] || p.sub) + '</p><div class="rrow"><span>' + money(p.price) + '</span><button class="add" type="button" data-add="' + pick + '">' + esc(B.t.add) + '</button></div></div></div>';
      }
    }
    var RE = $('#dReco'); RE && (RE.innerHTML = reco);
  }

  var drawer = $('#drawer'), lastFocus = null;
  function openBag() {
    lastFocus = document.activeElement;
    var gTimer = null;
  function saveGift(on, msg) { return req(R.update + '.js', { attributes: { 'Gift': on ? 'Yes' : '', 'Gift message': on ? msg : '' } }).then(render).catch(function () { toast(B.t.error); }); }
  document.addEventListener('change', function (e) {
    var cb = e.target.closest('[data-gift-on]'); if (!cb) return;
    var g = cb.closest('[data-gift]'), tx = $('[data-gift-text]', g), box = $('.bgmsg', g);
    box && (box.hidden = !cb.checked);
    saveGift(cb.checked, tx ? tx.value.trim() : '');
    if (cb.checked && tx) tx.focus({ preventScroll: true });
  });
  document.addEventListener('input', function (e) {
    var tx = e.target.closest('[data-gift-text]'); if (!tx) return;
    var g = tx.closest('[data-gift]'), k = $('[data-gift-cnt]', g); k && (k.textContent = tx.value.length);
    clearTimeout(gTimer); gTimer = setTimeout(function () { saveGift(true, tx.value.trim()); }, 700);
  });
  // prices written by Liquid (/cart, empty bag, Gifts) in the same format as the drawer
  $$('[data-m]').forEach(function (x) { x.textContent = money(+x.dataset.m); });
  getCart().then(render).catch(function () {});
    drawer.classList.add('on'); drawer.setAttribute('aria-hidden', 'false');
    var x = $('.xbtn', drawer); x && x.focus();
  }
  function closeBag() { drawer.classList.remove('on'); drawer.setAttribute('aria-hidden', 'true'); lastFocus && lastFocus.focus && lastFocus.focus(); }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { if (drawer.classList.contains('on')) closeBag(); var m = $('#wd'); m && m.classList.remove('on'); } });

  var toastT = null;
  function toast(msg) { var t = $('#toast'); if (!t) return; $('#toastT').textContent = msg; t.classList.add('on'); clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove('on'); }, 2600); }

  function add(items, attrs, opts) {
    opts = opts || {};
    var p = req(R.add + '.js', { items: items });
    if (attrs) p = p.then(function () { return req(R.update + '.js', { attributes: attrs }); });
    return p.then(getCart).then(function (c) {
      render(c);
      if (opts.checkout) { location.href = '/checkout'; return c; }
      if (opts.toast) toast(opts.toast); else openBag();
      return c;
    }).catch(function (e) { toast((e && (e.description || e.message)) || B.t.error); throw e; });
  }
  // quantity and remove in the bag: one request at a time, errors (e.g. not enough stock) as a toast
  var busy = false;
  function change(key, q) {
    if (busy) return; busy = true; drawer && drawer.classList.add('busy');
    req(R.change + '.js', { id: key, quantity: q }).then(function (c) { if (document.body.classList.contains('t-cart')) { location.reload(); return; } render(c); })
      .catch(function (e) { toast((e && (e.description || e.message)) || B.t.error); return getCart().then(render); })
      .then(function () { busy = false; drawer && drawer.classList.remove('busy'); }, function () { busy = false; drawer && drawer.classList.remove('busy'); });
  }
  window.BEEAcart = { add: add, open: openBag, close: closeBag, get: getCart, render: render, money: money, change: change };

  document.addEventListener('click', function (e) {
    var t = e.target;
    var ob = t.closest('[data-openbag]'); if (ob) { e.preventDefault(); openBag(); return; }
    if (t.closest('[data-close]')) { closeBag(); return; }
    var rm = t.closest('[data-rm]'); if (rm) { change(rm.dataset.rm, 0); return; }
    var qk = t.closest('[data-qk]');
    if (qk) {
      var line = qk.closest('.dline'), cur = +((line && $('output', line) || {}).textContent || 1);
      change(qk.dataset.qk, Math.max(0, cur + (+qk.dataset.d)));
      return;
    }
    var ad = t.closest('[data-add]');
    if (ad) {
      var d = B.devices[ad.dataset.add]; if (!d || !d.variant) return;
      var inDrawer = !!ad.closest('#drawer');
      ad.classList.add('done');
      add([{ id: d.variant, quantity: 1 }], null, inDrawer ? { toast: '' } : { toast: tt(B.t.added, { name: d.name, price: money(d.price) }) })
        .then(function () { var o = ad.textContent; if (!inDrawer) { ad.textContent = B.t.added_short; setTimeout(function () { ad.textContent = o; ad.classList.remove('done'); }, 1600); } else { openBag(); } })
        .catch(function () { ad.classList.remove('done'); });
      return;
    }
    var ga = t.closest('[data-gift-add]');
    if (ga) {
      var gd = B.devices[ga.dataset.giftAdd]; if (!gd || !gd.variant) return;
      ga.classList.add('done');
      add([{ id: gd.variant, quantity: 1 }], { 'Gift': 'Yes' }).then(function () { ga.classList.remove('done'); }, function () { ga.classList.remove('done'); });
      return;
    }
    var gcb = t.closest('[data-gcbuy]');
    if (gcb) {
      var on = $('#amts button.on[data-gcv]') || $('#amts button[data-gcv]'); if (!on) return;
      var it = { id: +on.dataset.gcv, quantity: 1 }, to = document.getElementById('gcTo');
      if (to && to.checked) { var em = (document.getElementById('gcMail').value || '').trim(), er = document.getElementById('gcErr');
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(em)) { er.textContent = er.dataset.err; return; } er.textContent = '';
        it.properties = { 'Recipient email': em, 'Recipient name': (document.getElementById('gcName').value || '').trim(), 'Message': (document.getElementById('gcMsg').value || '').trim(), '__shopify_send_gift_card_to_recipient': 'on' };
        var dt = document.getElementById('gcDate').value; if (dt) it.properties['Send on'] = dt; }
      add([it]).catch(function () {});
      return;
    }
    var bg = t.closest('[data-burger]');
    if (bg) { var m = $('#mnav'), on = m.hasAttribute('hidden'); if (on) m.removeAttribute('hidden'); else m.setAttribute('hidden', ''); bg.setAttribute('aria-expanded', String(on)); document.documentElement.classList.toggle('mlock', on); return; }
    if (t.closest('[data-cookie]')) { if (window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.showPreferences) Shopify.customerPrivacy.showPreferences(); return; }
  });
  getCart().then(render).catch(function () {});

  /* Online withdrawal flow (ZZP čl. 81.a). Draft: nothing is sent yet. */
  var wd = $('#wd');
  if (wd) {
    var step = function (n) { $$('#wd .mstep').forEach(function (s) { s.classList.toggle('on', s.dataset.s === String(n)); }); };
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-wd]')) { e.preventDefault(); step(1); wd.classList.add('on'); var i = $('#wdName'); i && i.focus(); }
      if (e.target.closest('[data-wdclose]')) wd.classList.remove('on');
    });
    $('#wdNext').addEventListener('click', function () {
      var n = $('#wdName').value.trim(), o = $('#wdOrder').value.trim(), m = $('#wdMail').value.trim(), it = $('#wdItems').value.trim();
      if (!n || !o || !m) { $('#wdErr').classList.add('on'); return; }
      $('#wdErr').classList.remove('on');
      $('#wdSumm').innerHTML = '<div><span>' + esc(B.t.wd_name) + '</span><br>' + esc(n) + '</div><div><span>' + esc(B.t.wd_order) + '</span><br>' + esc(o) + '</div><div><span>' + esc(B.t.wd_to) + '</span><br>' + esc(m) + '</div><div><span>' + esc(B.t.wd_products) + '</span><br>' + (it ? esc(it) : esc(B.t.wd_whole)) + '</div>';
      step(2);
    });
    $('#wdBack').addEventListener('click', function () { step(1); });
    /* Confirm: on the live theme it sends (1) a Klaviyo event "Withdrawal Requested", which triggers the L1 confirmation email
       with the date and time, and (2) the store's own contact form, so info@beea.hr has a copy even if a blocker stops Klaviyo.
       A draft or preview theme sends nothing unless the address has ?wdtest=1 (BF04, Karlo 3 Oct 2026). */
    var live = (window.Shopify && Shopify.theme && Shopify.theme.role === 'main') || /[?&]wdtest=1/.test(location.search);
    if (live) $$('#wd .proto').forEach(function (x) { x.hidden = true; });
    function sendWithdrawal(d) {
      var jobs = [];
      if (B.klaviyo) {
        var parts = d.name.split(/\s+/);
        jobs.push(fetch('https://a.klaviyo.com/client/events?company_id=' + encodeURIComponent(B.klaviyo), {
          method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json', 'revision': '2025-01-15' },
          body: JSON.stringify({ data: { type: 'event', attributes: {
            properties: { order_number: d.order, items: d.items || B.t.wd_whole, full_name: d.name, received_at: d.when.toISOString(), locale: B.locale, source: 'withdrawal form' },
            time: d.when.toISOString(), unique_id: 'wd-' + d.when.getTime() + '-' + d.order.replace(/\W/g, ''),
            metric: { data: { type: 'metric', attributes: { name: 'Withdrawal Requested' } } },
            profile: { data: { type: 'profile', attributes: { email: d.mail, first_name: parts[0], last_name: parts.slice(1).join(' ') } } } } } })
        }).then(function (r) { if (!r.ok) throw r; return 1; }));
      }
      var fd = new FormData(), root = (B.routes || {}).root || '/';
      fd.append('form_type', 'contact'); fd.append('utf8', '✓');
      fd.append('contact[email]', d.mail); fd.append('contact[name]', d.name); fd.append('contact[order]', d.order);
      fd.append('contact[body]', 'WITHDRAWAL FROM CONTRACT / RASKID UGOVORA (ZZP cl. 81.a)\nName: ' + d.name + '\nOrder: ' + d.order + '\nProducts: ' + (d.items || B.t.wd_whole) + '\nEmail: ' + d.mail + '\nReceived: ' + d.when.toISOString());
      jobs.push(fetch((root === '/' ? '' : root) + '/contact', { method: 'POST', body: fd, credentials: 'same-origin' }).then(function (r) { if (!r.ok || /challenge/.test(r.url || '')) throw r; return 1; }));
      return Promise.all(jobs.map(function (j) { return j.then(function () { return 1; }, function () { return 0; }); }))
        .then(function (r) { if (!r.some(Boolean)) throw new Error('not sent'); });
    }
    $('#wdConfirm').addEventListener('click', function () {
      var btn = this, now = new Date();
      var when = now.toLocaleString(B.locale === 'hr' ? 'hr-HR' : 'en-GB', { day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Zagreb' });
      var done = function () { $('#wdWhen').textContent = tt(B.t.wd_received, { when: when }); $('#wdErr2').classList.remove('on'); step(3); btn.disabled = false; };
      if (!live) { done(); return; }
      btn.disabled = true;
      sendWithdrawal({ name: $('#wdName').value.trim(), order: $('#wdOrder').value.trim(), mail: $('#wdMail').value.trim(), items: $('#wdItems').value.trim(), when: now })
        .then(done, function () { btn.disabled = false; $('#wdErr2').classList.add('on'); });
    });
  }

  /* Christmas line: shown from 15 November to 24 December, or with ?xmas=1 */
  var d = new Date(), from = new Date(d.getFullYear(), 10, 15), to = new Date(d.getFullYear(), 11, 24);
  var show = /[?&]xmas=1/.test(location.search) || (d >= from && d <= to);
  $$('.xmas').forEach(function (x) { x.classList.toggle('on', show); });

  /* In-page links scroll smoothly; the rest of the page is plain HTML */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]'); if (!a) return;
    var id = a.getAttribute('href').slice(1); if (!id) { if (a.classList.contains('nsoon')) e.preventDefault(); return; }
    var el = document.getElementById(id); if (!el) return;
    e.preventDefault(); el.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  });
})();

/* Shopify's own preview bar (only when a draft theme is previewed, never for shoppers) covers the bottom 60 to 70 px.
   Lift the floating Add to bag and the routine tab above it, so the preview shows what shoppers will see. */
(function () {
  if (!(window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main')) return;
  var root = document.documentElement, last = -1;
  function lift() {
    var h = 0;
    document.querySelectorAll('#PBarNextFrameWrapper,#preview-bar-iframe').forEach(function (e) {
      var r = e.getBoundingClientRect(), c = getComputedStyle(e);
      if (c.display !== 'none' && c.visibility !== 'hidden' && r.height > 0 && r.bottom >= innerHeight - 2) h = Math.max(h, Math.round(innerHeight - r.top));
    });
    if (h !== last) { last = h; root.style.setProperty('--pbar', h + 'px'); }
  }
  lift(); setInterval(lift, 1000); window.addEventListener('resize', lift);
})();

/* Trust bar on phones: one line at a time, every 4 s; a tap pauses it; nothing moves with reduced motion (BP06, 3 Oct). */
(function () {
  var b = document.querySelector('[data-rot]'); if (!b) return;
  var s = [].slice.call(b.children), i = 0, t = null, paused = false;
  var mq = matchMedia('(max-width:900px)'), still = matchMedia('(prefers-reduced-motion: reduce)');
  function show(n) { s.forEach(function (x, k) { x.classList.toggle('on', k === n); }); }
  function stop() { clearInterval(t); t = null; }
  function go() { stop(); if (!mq.matches || still.matches || paused) return; t = setInterval(function () { i = (i + 1) % s.length; show(i); }, 4000); }
  b.addEventListener('click', function () { paused = !paused; b.classList.toggle('paused', paused); go(); });
  document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else go(); });
  mq.addEventListener && mq.addEventListener('change', function () { show(i = 0); go(); });
  go();
})();

/* Footer: Help and BEEA fold on phones and stay open on desktop (BF04, 3 Oct). */
(function () {
  var d = [].slice.call(document.querySelectorAll('details[data-fcol]')); if (!d.length) return;
  var mq = matchMedia('(min-width:901px)');
  function f() { d.forEach(function (x) { x.open = mq.matches; }); }
  f(); mq.addEventListener && mq.addEventListener('change', f);
  d.forEach(function (x) { x.querySelector('summary').addEventListener('click', function (e) { if (mq.matches) e.preventDefault(); }); });
})();

/* Desktop product page: the floating Add to bag stays hidden while the buy box is on screen, so it never covers
   the gift option there (BP08, 3 Oct). Phones keep the bar as decided. */
(function () {
  var sb = document.querySelector('.sticky-buy'), buy = document.querySelector('aside.buy');
  if (!sb || !buy || !('IntersectionObserver' in window)) return;
  var mq = matchMedia('(min-width:901px)'), vis = false;
  function upd() { sb.classList.toggle('sb-hide', mq.matches && vis); }
  new IntersectionObserver(function (es) { vis = es[0].isIntersecting; upd(); }, { threshold: 0 }).observe(buy);
  mq.addEventListener && mq.addEventListener('change', upd);
})();

/* Surgeons block: the expert cards swipe sideways on phones; arrows move one card (Estetica 2026, 3 Oct). */
(function(){document.querySelectorAll('[data-xrow]').forEach(function(row){
  var nav=row.parentNode.querySelector('.xnav'); if(!nav) return;
  var b=nav.querySelectorAll('[data-xs]');
  function upd(){var max=row.scrollWidth-row.clientWidth-4; b[0].disabled=row.scrollLeft<=8; b[1].disabled=row.scrollLeft>=max; nav.hidden=max<=4;}
  b.forEach(function(x){x.addEventListener('click',function(){var c=row.querySelector('.xq'); var g=parseFloat(getComputedStyle(row).columnGap)||14;
    row.scrollBy({left:(+x.dataset.xs)*((c?c.getBoundingClientRect().width:row.clientWidth)+g),behavior:'smooth'});});});
  row.addEventListener('scroll',function(){requestAnimationFrame(upd)},{passive:true}); addEventListener('resize',upd); upd();
});})();

/* homenew: films, creators, tech teaser (14 Oct 2026) */
/* T53 home films: posters first; a clip gets its source only once its card is in view (preload none, nothing downloads
   before play). Desktop: hover plays and widens the card. Phone: tap plays or pauses. One clip at a time; a clip that
   leaves the screen stops. Reduced motion: no hover play, a tap or click still plays. */
(function(){
  var row=document.querySelector('[data-hf-row]'); if(!row) return;
  var cards=[].slice.call(row.querySelectorAll('.hf-card'));
  var fine=window.matchMedia('(hover:hover) and (pointer:fine) and (min-width:900px)'), rm=window.matchMedia('(prefers-reduced-motion: reduce)');
  function vid(c){return c.querySelector('video')}
  function arm(c){var v=vid(c); if(!v.getAttribute('src')&&v.dataset.src) v.setAttribute('src',v.dataset.src)}
  function label(c,on){var b=c.querySelector('.hf-play'); b.setAttribute('aria-pressed',on?'true':'false'); b.setAttribute('aria-label',on?b.dataset.lPause:b.dataset.lPlay)}
  function stop(c){var v=vid(c); c.classList.remove('on'); label(c,false); if(!v.paused) v.pause()}
  function play(c){
    cards.forEach(function(x){if(x!==c) stop(x)});
    arm(c); c.classList.add('on'); label(c,true);
    var p=vid(c).play(); if(p&&p.catch) p.catch(function(){stop(c)});
  }
  cards.forEach(function(c){
    var v=vid(c);
    v.addEventListener('playing',function(){c.classList.add('pv')});
    v.addEventListener('pause',function(){c.classList.remove('pv')});
    c.addEventListener('mouseenter',function(){if(fine.matches&&!rm.matches) play(c)});
    c.addEventListener('mouseleave',function(){if(fine.matches) stop(c)});
    c.querySelector('.hf-play').addEventListener('click',function(){if(c.classList.contains('on')) stop(c); else play(c)});
  });
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){
      if(e.isIntersecting) arm(e.target); else if(e.target.classList.contains('on')) stop(e.target);
    })});
    cards.forEach(function(c){io.observe(c)});
  } else cards.forEach(arm);
})();
/* T62 home technology teaser: the small wave drawings run only while the strip is on screen. */
(function(){
  var s=document.querySelector('[data-tt]'); if(!s||!('IntersectionObserver' in window)) return;
  new IntersectionObserver(function(es){es.forEach(function(e){s.classList.toggle('tt-off',!e.isIntersecting)})}).observe(s);
})();

/* gift card: recipient fields (T61) */
(function(){var to=document.getElementById('gcTo'),f=document.getElementById('gcF');if(!to||!f)return;to.addEventListener('change',function(){f.hidden=!to.checked;if(to.checked)document.getElementById('gcName').focus()});})();
